import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '@openedx/paragon';

import SectionSubHeader from '../../generic/section-sub-header';
import TagsChipsField from '../TagsChipsField';

const SocialSection = ({ socialTeam, socialChannels, onChange }) => (
  <section className="section-container social-section">
    <SectionSubHeader
      title="Social"
      description="Social team and channel information for this course."
    />
    <Form.Group className="form-group-custom">
      <Form.Label>Social Team</Form.Label>
      <Form.Control
        value={socialTeam}
        onChange={(e) => onChange(e.target.value, 'socialTeam')}
      />
    </Form.Group>
    <TagsChipsField
      fieldKey="socialChannels"
      label="Social Channels"
      tags={socialChannels || []}
      onChange={onChange}
    />
  </section>
);

SocialSection.defaultProps = {
  socialTeam: '',
  socialChannels: [],
};

SocialSection.propTypes = {
  socialTeam: PropTypes.string,
  socialChannels: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

export default SocialSection;
